import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Calendar } from "lucide-react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./Blog.css";

const FALLBACK_BLOGS = [
  {
    id: "blog-1",
    title: "Top Emerging Real Estate Investment Corridors in India 2026",
    excerpt: "An in-depth analysis of high-growth micro-markets, metro connectivity impacts, and infrastructure projects driving maximum capital appreciation.",
    imageUrl: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800&auto=format&fit=crop",
    author: "AHD Research Team",
    date: "Aug 2026",
    readTime: "5 min read",
    tag: "Market Insights",
    slug: "emerging-real-estate-investment-corridors-2026",
  },
  {
    id: "blog-2",
    title: "The Ultimate First-Time Homebuyer Checklist & Legal Guide",
    excerpt: "Everything you need to know about RERA compliance, title verification, home loan eligibility, and hidden transaction costs before signing.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=800&auto=format&fit=crop",
    author: "Advisory Desk",
    date: "Aug 2026",
    readTime: "7 min read",
    tag: "Home Buying",
    slug: "first-time-homebuyer-checklist-legal-guide",
  },
  {
    id: "blog-3",
    title: "Smart Interior Design: Maximizing Natural Light in Luxury Spaces",
    excerpt: "Explore contemporary architectural trends, sustainable materials, and open-plan concepts that bring spacious tranquility to city living.",
    imageUrl: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?q=80&w=800&auto=format&fit=crop",
    author: "AHD Design Studio",
    date: "Aug 2026",
    readTime: "4 min read",
    tag: "Interior Design",
    slug: "smart-interior-design-maximizing-natural-light",
  },
];

const BlogListSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const response = await axios.post(
          `${baseUrl}/all/blogs/home`,
          { page_number: 1, page_size: 3, order_by: "ASC" },
          { headers }
        );
        if (
          response.data?.statusType === "SUCCESS" &&
          response.data.blogs &&
          response.data.blogs.length > 0
        ) {
          setBlogs(response.data.blogs);
        } else {
          setBlogs(FALLBACK_BLOGS);
        }
      } catch (error) {
        setBlogs(FALLBACK_BLOGS);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, [baseUrl, token]);

  return (
    <section className="blog-section">
      <div className="blog-section__container">
        <div className="blog-section__header">
          <div>
            <span className="blog-section__label">Articles & Insights</span>
            <h2 className="blog-section__title">
              Latest from our <em>Knowledge Hub</em>
            </h2>
          </div>
          <Link to="/view/all/blogs" className="blog-section__view-all">
            <span>Explore All Articles</span>
            <ArrowRight size={15} strokeWidth={2.5} />
          </Link>
        </div>

        <div className="blog-section__grid">
          {blogs.map((blog, idx) => {
            const imgSrc =
              blog.imageUrl ||
              blog.image_url ||
              FALLBACK_BLOGS[idx % FALLBACK_BLOGS.length].imageUrl;
            const categoryTag = blog.tag || (blog.tags ? blog.tags.split(",")[0] : "Real Estate");
            const readTime = blog.readTime || "5 min read";
            const dateStr = typeof blog.date === "string" ? blog.date : "Aug 2026";

            return (
              <article key={blog.id || blog._id || idx} className="blog-card">
                <div className="blog-card__img-wrap">
                  <img src={imgSrc} alt={blog.title} className="blog-card__img" />
                  <span className="blog-card__tag">{categoryTag}</span>
                </div>
                <div className="blog-card__body">
                  <div className="blog-card__meta">
                    <span className="blog-card__meta-item">
                      <Calendar size={13} /> {dateStr}
                    </span>
                    <span className="blog-card__meta-item">
                      <Clock size={13} /> {readTime}
                    </span>
                  </div>

                  <h3 className="blog-card__title">{blog.title}</h3>

                  <p className="blog-card__excerpt">
                    {blog.excerpt || (blog.description ? blog.description.slice(0, 110) : "")}…
                  </p>

                  <Link
                    to={blog.slug ? `/blog/${blog.slug}` : `/view/all/blogs`}
                    className="blog-card__read-more"
                  >
                    <span>Read Article</span>
                    <ArrowRight size={14} strokeWidth={2.5} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogListSection;